import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200140Status: 'idle',
    startProcess200140Error: undefined as any,
    loadUserParamsProcess200140Status: 'idle',
    loadUserParamsProcess200140Error: undefined as any,

    process200140List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200140 = createAsyncThunk('process200140Slice/startProcess200140', async ({ process200140 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200140/`,
        prepareData(process200140),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200140Status } = getState().process200140Slice
        return startProcess200140Status !== 'pending'
    }
})

export const loadUserParamsProcess200140 = createAsyncThunk('process200140Slice/loadUserParamsProcess200140', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200140/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200140Status } = getState().process200140Slice
        return loadUserParamsProcess200140Status !== 'pending'
    }
})

const Process200140Slice = createSlice({
    name: 'process200140Slice',
    initialState,
    reducers: {
        resetstartProcess200140: (state) => {
            state.job = undefined
            state.startProcess200140Error = undefined
        },
        resetstartProcess200140Error: (state) => {
            state.startProcess200140Error = undefined
        },
        resetloadUserParamsProcess200140: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200140Error = undefined
        },
        resetloadUserParamsProcess200140Error: (state) => {
            state.loadUserParamsProcess200140Error = undefined
        },
        removeFromProcess200140ListById: (state, action) => {
            state.process200140List = state.process200140List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200140ListByIds: (state, action) => {
            state.process200140List = state.process200140List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200140List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200140Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200140List = []
            state.startProcess200140Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200140.pending, (state) => {
            state.startProcess200140Status = 'pending'
            state.startProcess200140Error = undefined
        })
        builder.addCase(startProcess200140.fulfilled, (state, action) => {
            state.startProcess200140Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200140.rejected, (state, action) => {
            state.startProcess200140Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200140Error = action.error.message
            } else {
                state.startProcess200140Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200140.pending, (state) => {
            state.loadUserParamsProcess200140Status = 'pending'
            state.loadUserParamsProcess200140Error = undefined
        })
        builder.addCase(loadUserParamsProcess200140.fulfilled, (state, action) => {
            state.loadUserParamsProcess200140Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200140.rejected, (state, action) => {
            state.loadUserParamsProcess200140Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200140Error = action.error.message
            } else {
                state.loadUserParamsProcess200140Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200140,
    resetstartProcess200140Error,
    resetloadUserParamsProcess200140,
    resetloadUserParamsProcess200140Error,
    removeFromProcess200140ListById,
    removeFromProcess200140ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200140Slice.actions
export default Process200140Slice.reducer
